import { render, staticRenderFns } from "./SimpleTextEditRoot.vue?vue&type=template&id=f66f45a2"
import script from "./SimpleTextEditRoot.vue?vue&type=script&lang=ts"
export * from "./SimpleTextEditRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports